// extracted by mini-css-extract-plugin
export default {"title":"Title_title__pXjRC","progress":"Title_progress__XkZRi","inner":"Title_inner__KBiJt"};